import { RequestTypeCodes } from '@Enum/index';
import { getITReqEnable, getResignationEnable } from '@Utils/getFeatureFlag';

// TODO: feature flag for dev env
const isITReqEnable = getITReqEnable();
const isResignationEnable = getResignationEnable();

export const requestTypeOptionsAllowed: Record<number, boolean> = {
  [RequestTypeCodes.LEAVE_REQUEST]: true,
  [RequestTypeCodes.PASSPORT_REQUEST]: true,
  [RequestTypeCodes.RESUMPTION_REQUEST]: true,
  [RequestTypeCodes.SALARY_CERTIFICATE]: true,
  [RequestTypeCodes.OVERSEAS_MISSION]: true,
  // TODO: Hide IT-Requisition by client request
  [RequestTypeCodes.IT_REQUISITION]: isITReqEnable,
  // TODO: Hide Resignation request by 1631 task
  [RequestTypeCodes.RESIGNATION_REQUEST]: isResignationEnable,
  [RequestTypeCodes.ATTENDANCE_REQUEST]: true,
};
